import { formatServerDateTime } from '@adiox/ui';
import { useDataWindow } from './dataWindowModel';

const row = 'flex justify-between gap-3 border-b border-line/40 px-2 py-0.5';

/**
 * MT5's Data Window (Ctrl+D): the bar under the cursor of whichever chart the cursor is on (the active chart's newest bar
 * otherwise), its prices and volume, and every indicator's values on that bar.
 */
export function DataWindow() {
  const { symbol, tf, digits, bar, indicators } = useDataWindow();
  if (!symbol || !tf || !bar) {
    return (
      <section className="h-full bg-panel p-3 text-sm text-muted" aria-label="Data Window">
        Point at a bar on a chart to see its values here.
      </section>
    );
  }
  const fmt = (v: number) => v.toFixed(digits);
  return (
    <section className="h-full overflow-auto bg-panel text-sm" aria-label="Data Window">
      <dl data-testid="data-window">
        <div className={`${row} font-semibold`}>
          <dt>{symbol}</dt>
          <dd>{tf}</dd>
        </div>
        <div className={row}>
          <dt className="text-muted">Date</dt>
          {/* bar times are the server's clock already */}
          <dd className="num">{formatServerDateTime(bar.t * 1000, 0)}</dd>
        </div>
        {(
          [
            ['Open', fmt(bar.o)],
            ['High', fmt(bar.h)],
            ['Low', fmt(bar.l)],
            ['Close', fmt(bar.c)],
            ['Tick volume', String(bar.tv)],
            ['Spread', String(bar.sp)],
          ] as const
        ).map(([label, value]) => (
          <div key={label} className={row}>
            <dt className="text-muted">{label}</dt>
            <dd className="num">{value}</dd>
          </div>
        ))}
        {indicators.map((ind) => (
          <div key={ind.uid} data-testid="data-window-indicator">
            <div className="bg-panel2 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-muted">
              {ind.title}
            </div>
            {ind.values.map((v) => (
              <div key={v.label} className={row}>
                <dt style={{ color: v.color }}>{v.label}</dt>
                <dd className="num">{v.text}</dd>
              </div>
            ))}
          </div>
        ))}
      </dl>
      <p className="px-2 py-1 text-xs text-muted">
        The date is the bar's opening time, server time, like the chart.
      </p>
    </section>
  );
}
